<template>
  <div class="mm-page-main">
    <div v-if="!editstatus">
      <div class="page-header">
        <div class="page-title">賣出交易詳情</div>
        <div @click="pageback" class="page-back">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-back"></use>
          </svg>
        </div>
      </div>
      <div class="pagemain">
        <div class="boxhader">
          <div class="box-left">
          </div>
          <div class="box-right">
            <div class="changeorderstatus">
              <div>交易進度：</div>
              <div class="changstatusbox">
                <el-select @change="setstatus(busness_status)" :disabled="busness_status==3||busness_status==5||isreadonly" v-model="busness_status" placeholder="請選擇">
                  <el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="mm-ml15" v-if="busness_status==0&&!isreadonly">
                <el-button type="primary" @click="editstatus=true;">編輯</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="box-group" style="padding-bottom: 0;">
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">建立部門</div>
              <div>
                 {{data.sectorname?data.sectorname:(data.store_short+' '+data.store_name)}}
              </div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">所屬門店</div>
              <div>{{data.store_short}} {{data.store_name}}</div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">開單員工</div>
              <div>{{data.username}}<span v-if="data.operator!=''">({{data.operator}})</span></div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">業務類型</div>
              <div>
                <el-radio-group disabled v-model="data.type">
                  <el-radio-button label="0">兌換</el-radio-button>
                  <el-radio-button label="1">匯款</el-radio-button>
                  <el-radio-button label="2">內部記賬</el-radio-button>

                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">交易編號</div>
              <div>S{{data.businessnum}}</div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">關聯訂單</div>
              <div v-if="data.order_id>0">
                <span v-if="data.ordertype == 0">{{data.store_short}}-C{{data.ordernum}}</span>
                <span v-if="data.ordertype == 1">{{data.store_short}}-R{{data.ordernum}}</span>
                <span v-if="data.ordertype == 2">{{data.store_short}}-I{{data.ordernum}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box-group backgroup">
          <div class="mm-row">
            <div class="mm-item mm-phone">
              <div class="mm-label">交易方式</div>
              <div>
                <el-radio-group disabled v-model="data.mode">
                  <el-radio-button label="0">現金</el-radio-button>
                  <el-radio-button label="1">銀行轉賬</el-radio-button>
                  <el-radio-button label="2">特別賬戶</el-radio-button>

                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-col">
              <div class="mm-item mb20">
                <label class="mm-label">交易戶口</label>
                <div v-if="data.mode==0">
                  {{data.store_name}}
                  {{data.currency_name}}
                  {{data.currency_short_name}}
                  <template v-if="data.status==3">
                    （貨幣結餘：{{tomoney(data.cash_balance.surplus)}} {{data.currency_short_name}}）
                  </template>
                </div>
                <div v-if="data.mode==1">
                  <div v-if="data.bank_account.id">
                    {{data.bank_account.account_name}} {{addSpace(data.bank_account.account_num)}}
                    {{data.bank_account.bankname}}
                    {{data.currency_name}}
                    {{data.currency_short_name}}
                    <template v-if="data.status==3">
                      （賬戶結餘：{{tomoney(data.bank_balance.surplus)}} {{data.currency_short_name}}）
                    </template>
                  </div>
                  <div v-else>未關聯賬戶</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="mm-row">
						<div class="mm-item">
							<div class="mm-label">交易賬號</div>
							<div style="width: 400px;">
								<el-select disabled="" v-model="aa" placeholder="請選擇">
									<el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
					</div> -->
          <div class="mm-row">
            <div class="mm-item mm-phone">
              <div class="mm-label">交易金額</div>
              <div>
                <div class="mm-phone-item">
                  <el-select disabled="" v-model="data.currency_id" placeholder="請選擇">
                    <el-option v-for="item in currency" :key="item.id" :label="item.short_name+' '+item.name" :value="item.id"></el-option>
                  </el-select>
                </div>
                <div class="mm-phone-item">
                  <el-input disabled="" v-model="data.money"></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">折合港幣</div>
              <div class="mm-flex">
                <div>
                  <el-input disabled="" v-model="data.hkd"></el-input>
                </div>
                <div class="zhehe">
                  @<span>{{data.rate}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-group">
          <div class="mm-row">
            <div class="mm-item mm-phone">
              <div class="mm-label">交易類型</div>
              <div>
                <el-radio-group disabled v-model="data.business_type">
                  <el-radio-button v-if="data.type == 0" label="0">兌換</el-radio-button>
                  <el-radio-button v-else-if="data.type == 1" label="0">匯款</el-radio-button>
                  <el-radio-button label="1">客戶結餘</el-radio-button>
                  <el-radio-button label="3">手續費支出</el-radio-button>
                  <el-radio-button label="4">運營資金</el-radio-button>
                  <el-radio-button label="7">API出數</el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="mm-row" v-if="data.customer_id">
            <div class="mm-item mm-phone">
              <div class="mm-label">關聯會員</div>
              <div>
                {{data.customer.type==0?'P':(data.customer.type==1?'C':'H')}}{{data.customer.customer_num}}
                {{data.customer.name}}
                {{data.customer.ename}}
                {{data.customer.phone}}
                <template v-if="data.status==3">
                  <template v-if="data.mode==0">
                    （客戶貨幣結餘：{{tomoney(data.cash_balance.customer_surplus)}} {{data.currency_short_name}}）
                  </template>
                  <template v-else-if="data.mode==1">
                    （客戶賬戶結餘：{{tomoney(data.bank_balance.customer_surplus)}} {{data.currency_short_name}}）
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group-content backgroup" v-if="(data.type == 1||data.type == 2)&&(data.mode==1)">
          <div class="mm-row">
            <div class="mm-col">
              <div class="mm-item mb20">
                <label class="mm-label">貨幣類型：</label>
                <el-radio-group disabled v-model="remittance.area">
                  <el-radio-button label="0">港幣</el-radio-button>
                  <el-radio-button label="1">人民幣</el-radio-button>
                  <el-radio-button label="2">外幣</el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div v-if="remittance.area == 0">
            <hkbanksinfo :data.sync="remittance" />
          </div>
          <div v-if="remittance.area == 1">
            <banksinfo :data.sync="remittance" />
          </div>
          <div v-if="remittance.area == 2">
            <overseasbanksinfo :data.sync="remittance" />
          </div>
        </div>
        <div class="box-group">
          <div class="mm-row" style="margin-bottom: 30px;">
            <div class="mm-item">
              <div class="mm-label">水單上傳</div>
              <div>
                <el-upload disabled action="#" :file-list="files" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="showpicbox">
                  <img width="100%" :src="showpicurl" alt="">
                </el-dialog>
              </div>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-item">
              <div class="mm-label">備註</div>
              <div>
                <el-input disabled="" type="textarea" :rows="2" placeholder="請輸入內容" v-model="data.mark"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editstatus">
      <div class="page-header">
        <div class="page-title">編輯交易信息</div>
        <div @click="endedit()" class="page-back">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-back"></use>
          </svg>
        </div>
      </div>
      <sellbuinessedit :visible.sync="editstatus" :showdata="data" :id="id" @submit="getdata"></sellbuinessedit>
    </div>
  </div>
</template>
<script>
import banksinfo from "@/components/BanksInfo.vue";
import hkbanksinfo from "@/components/HKBanksInfo.vue";
import overseasbanksinfo from "@/components/OverseasBanksInfo.vue";
import sellbuinessedit from "@/components/SellBusinessEdit.vue";
export default {
  components: {
    hkbanksinfo,
    banksinfo,
    overseasbanksinfo,
    sellbuinessedit
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isedit: {
      type: Boolean,
      default: false,
    },
    isreadonly:{
      type:Boolean,
      default:false,
    }
  },
  data () {
    return {
      editstatus: false,
      data: [],
      showpicurl: '',
      showpicbox: false,
      currency: [],
      files: [],
      remittance: {},
      business_id: 0,
      status_options: [{
        value: 0,
        label: '準備中 Pending'
      },
      {
        value: 1,
        label: '已審核 Approved'
      },
      {
        value: 2,
        label: '處理中 Processing'
      },
      {
        value: 3,
        label: '已完成 Successful'
      },
      {
        value: 4,
        label: '失敗 Fail'
      },
      {
        value: 5,
        label: '已刪除 Deleted'
      },

      ],
      busness_status: 3,
      type: 0,
    };
  },
  methods: {
    setstatus (status) {
      let business_id = this.business_id;
      let staff_id = sessionStorage.getItem('staff_id');
      this.loading = true;
      this.post('/api/business/setstatus', {
        staff_id: staff_id,
        business_id: this.business_id,
        status: status
      }).then((res) => {
        this.loading = false;
        if (res.status == 'success') {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }else{
          this.$message({
            message: '修改失敗',
            type: 'error'
          });
        }
        this.getdata();
      }).catch((err) => {

        console.log(err)
      })
    },
    endedit () {
      if (this.isedit) {
        this.pageback();
        this.editstatus = false;
      } else {
        this.editstatus = false;
      }
    },
    delpic (file, fileList) {

    },
    viewpic (file) {
      this.showpicurl = file.url;
      this.showpicbox = true;
    },
    pageback () {
      // this.$router.go(-1);
      this.$emit('update:visible', false);
      this.$emit('refresh', {});
    },


    getdata () {
      this.files = [];
      this.post('/api/business/selldetails', {
        business_id: this.business_id
      }).then((res) => {
        res.files.map((v) => {
          let file = {
            name: '',
            url: this.apiurl + v.fileurl
          }
          this.files.push(file);
        })
        this.data = res;
        this.remittance = res.remittance;
        this.busness_status = res.status;
        this.editstatus = this.isedit;

      }).catch((err) => {

        console.log(err)
      })
    },
    getcurrency () {
      this.post('/api/business/currencylist', {

      }).then((res) => {

        this.currency = res;

      }).catch((err) => {

        console.log(err)
      }).then(() => {
        this.getdata();
      })
    }

  },
  created () {
    this.business_id = this.id;
    this.getcurrency();
  }

};
</script>
<style scoped>
.boxhader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.box-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box-left > div {
  margin-right: 20px;
}

.changeorderstatus {
  display: flex;
  align-items: center;
}

.box {
  border-radius: 4px;
  border: 1px solid #ebeef5;

  padding: 0 5px;
}

.mm-row {
  margin: 10px 0;
}

.box-group {
  padding: 20px;
}

.backgroup {
  background: #fafafa;

  border: 1px solid #ebeef5;
  border-radius: 4px;
  min-height: 200px;
}
.backgroup .mm-row {
  margin: 30px 0;
}
@media screen and (max-width: 1024px) {
  .box-group {
    padding: 10px 0;
    margin: 0;
  }
  .mm-row {
    margin: 0 !important;
    padding: 5px 10px !important;
  }
  .form-group-content {
    min-height: auto;
  }
  .mb20 {
    margin: 0;
  }
  .mm-phone-item {
    margin: 5px 0;
  }
}
@media screen and (max-width: 320px) {
  .form-group-content {
    min-height: auto;
  }
  .mm-item.mm-phone {
    display: block;
  }
}
</style>
